/**
 * Store currency: same UI/UX as language selector; rounding/formatting matches bbhub (charm, zero-decimal, nice steps).
 */
(function () {
  var backendUrl = window.STORE_CHECKOUT_BACKEND_URL;
  var cookieName = 'store_currency';
  var cookieMaxAge = 60 * 60 * 24;
  var cacheKey = 'store_currency_state_v1';
  var cacheTtlMs = 60 * 60 * 1000;
  var initTimeoutMs = 6000;

  var CHARM_PRICING = { USD: 1, GBP: 1, EUR: 1, CAD: 1, KWD: 1, BHD: 1, OMR: 1 };
  var ZERO_DECIMAL = { BIF: 1, CLP: 1, DJF: 1, GNF: 1, ISK: 1, JPY: 1, KMF: 1, KRW: 1, PYG: 1, RUB: 1, RWF: 1, UGX: 1, VND: 1, VUV: 1, XAF: 1, XOF: 1, XPF: 1 };
  var CUSTOM_SYMBOLS = {
    SAR: '\uFDFC',
    AED: 'د.إ',
    TRY: '\u20BA',
    INR: '\u20B9',
    RUB: '\u20BD',
    KRW: '\u20A9',
    JPY: '\u00A5',
    CNY: '\u5143',
    PLN: 'z\u0142',
    BRL: 'R$',
    MXN: 'Mex$',
    SEK: 'kr',
    NOK: 'kr',
    DKK: 'kr',
    QAR: 'QR',
    OMR: 'R.O.',
    KWD: 'KD',
    BHD: 'BD',
    CHF: 'Fr.',
    HKD: 'HK$',
    SGD: 'S$'
  };
  var CURRENCY_NAMES = { USD: 'US Dollar', GBP: 'British Pound', EUR: 'Euro', CAD: 'Canadian Dollar', AUD: 'Australian Dollar', SAR: 'Saudi Riyal', AED: 'UAE Dirham', QAR: 'Qatari Riyal', OMR: 'Omani Rial', KWD: 'Kuwaiti Dinar', BHD: 'Bahraini Dinar', TRY: 'Turkish Lira', JPY: 'Japanese Yen', INR: 'Indian Rupee', MXN: 'Mexican Peso', SEK: 'Swedish Krona', NOK: 'Norwegian Krone', DKK: 'Danish Krone', CHF: 'Swiss Franc', PLN: 'Polish Złoty', BRL: 'Brazilian Real', CNY: 'Chinese Yuan', KRW: 'South Korean Won', HKD: 'Hong Kong Dollar', SGD: 'Singapore Dollar' };
  var SAR_SVG_INLINE = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1124.14 1256.39" fill="currentColor" aria-hidden="true" class="store-currency-sar-symbol" style="height:1em;width:auto;vertical-align:middle;display:inline-block"><path d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z"/><path d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z"/></svg>';
  var AED_SVG_INLINE = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 870" fill="currentColor" aria-hidden="true" class="store-currency-aed-symbol" style="height:1em;width:auto;vertical-align:middle;display:inline-block"><path d="m88.3 1c0.4 0.6 2.6 3.3 4.7 5.9 15.3 18.2 26.8 47.8 33 85.1 4.1 24.5 4.3 32.2 4.3 125.6v87h-41.8c-38.2 0-42.6-0.2-50.1-1.7-11.8-2.5-24-9.2-32.2-17.8-6.5-6.9-6.3-7.3-5.9 13.6 0.5 17.3 0.7 19.2 3.2 28.6 4 14.9 9.5 26 17.8 35.9 11.3 13.6 22.8 21.2 39.2 26.3 3.5 1 10.9 1.4 37.1 1.6l32.7 0.5v43.3 43.4l-46.1-0.3-46.3-0.3-8-3.2c-9.5-3.8-13.8-6.6-23.1-14.9l-6.8-6.1 0.4 19.1c0.5 17.7 0.6 19.7 3.1 28.7 8.7 31.8 29.7 54.5 57.4 61.9 6.9 1.9 9.6 2 38.5 2.4l30.9 0.4v89.6c0 54.1-0.3 94-0.8 100.8-0.5 6.2-2.1 17.8-3.5 25.9-6.5 37.3-18.2 65.4-35 83.6l-3.4 3.7h169.1c101.1 0 176.7-0.4 187.8-0.9 19.5-1 63-5.3 72.8-7.4 3.1-0.6 8.9-1.5 12.7-2.1 8.1-1.2 21.5-4 40.8-8.9 27.2-6.8 52-15.3 76.3-26.1 7.6-3.4 29.4-14.5 35.2-18 3.1-1.8 6.8-4 8.2-4.7 3.9-2.1 10.4-6.3 19.9-13.1 4.7-3.4 9.4-6.7 10.4-7.4 4.2-2.8 18.7-14.9 25.3-21 25.1-23.1 46.1-48.8 62.4-76.3 2.3-4 5.3-9 6.6-11.1 3.3-5.6 16.9-33.6 18.2-37.8 0.6-1.9 1.4-3.9 1.8-4.3 2.6-3.4 17.6-50.6 19.4-60.9 0.6-3.3 0.9-3.8 3.4-4.3 1.6-0.3 24.9-0.3 51.8-0.1 53.8 0.4 53.8 0.4 65.7 5.9 6.7 3.1 8.7 4.5 16.1 11.2 9.7 8.7 8.8 10.1 8.2-11.7-0.4-12.8-0.9-20.7-1.8-23.9-3.4-12.3-4.2-14.9-7.2-21.1-9.8-21.4-26.2-36.7-47.2-44l-8.2-3-33.4-0.4-33.3-0.5 0.4-11.7c0.4-15.4 0.4-45.9-0.1-61.6l-0.4-12.6 44.6-0.2c38.2-0.2 45.3 0 49.5 1.1 12.6 3.5 21.1 8.3 31.5 17.8l5.8 5.4v-14.8c0-17.6-0.9-25.4-4.5-37-7.1-23.5-21.1-41-41.1-51.8-13-7-13.8-7.2-58.5-7.5-26.2-0.2-39.9-0.6-40.6-1.2-0.6-0.6-1.1-1.6-1.1-2.4 0-0.8-1.5-7.1-3.5-13.9-23.4-82.7-67.1-148.4-131-197.1-8.7-6.7-30-20.8-38.6-25.6-3.3-1.9-6.9-3.9-7.8-4.5-4.2-2.3-28.3-14.1-34.3-16.6-3.6-1.6-8.3-3.6-10.4-4.4-35.3-15.3-94.5-29.8-139.7-34.3-7.4-0.7-17.2-1.8-21.7-2.2-20.4-2.3-48.7-2.6-209.4-2.6-135.8 0-169.9 0.3-169.4 1zm330.7 43.3c33.8 2 54.6 4.6 78.9 10.5 74.2 17.6 126.4 54.8 164.3 117 3.5 5.8 18.3 36 20.5 42.1 10.5 28.3 15.6 45.1 20.1 67.3 1.1 5.4 2.6 12.6 3.3 16 0.7 3.3 1 6.4 0.7 6.7-0.5 0.4-100.9 0.6-223.3 0.5l-222.5-0.2-0.3-128.5c-0.1-70.6 0-129.3 0.3-130.4l0.4-1.9h71.1c39 0 78 0.4 86.5 0.9zm297.5 350.3c0.7 4.3 0.7 77.3 0 80.9l-0.6 2.7-227.5-0.2-227.4-0.3-0.2-42.4c-0.2-23.3 0-42.7 0.2-43.1 0.3-0.5 97.2-0.8 227.7-0.8h227.2zm-10.2 171.7c0.5 1.5-1.9 13.8-6.8 33.8-5.6 22.5-13.2 45.2-20.9 62-3.8 8.6-13.3 27.2-15.6 30.7-1.1 1.6-4.3 6.7-7.1 11.2-18 28.2-43.7 53.9-73 72.9-10.7 6.8-32.7 18.4-38.6 20.2-1.2 0.3-2.5 0.9-3 1.3-0.7 0.6-9.8 4-20.4 7.8-19.5 6.9-56.6 14.4-86.4 17.5-19.3 1.9-22.4 2-96.7 2h-76.9v-129.7-129.8l220.9-0.4c121.5-0.2 221.6-0.5 222.4-0.7 0.9-0.1 1.8 0.5 2.1 1.2z"/></svg>';

  function setCookie(code) {
    document.cookie = cookieName + '=' + encodeURIComponent(code) + '; path=/; max-age=' + cookieMaxAge + '; samesite=lax';
  }

  function getCookie() {
    var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + cookieName + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]).trim() : '';
  }

  function applyCookieToState(state) {
    var c = getCookie();
    if (c && state.list && state.list.indexOf(c.toUpperCase()) !== -1) state.current = c.toUpperCase();
  }

  function isCharmPricing(code) { return CHARM_PRICING[code]; }
  function isZeroDecimal(code) { return ZERO_DECIMAL[code]; }

  function roundUpToStep(value, step) {
    if (step <= 0 || !Number.isFinite(step)) return Math.ceil(value);
    return Math.ceil(value / step) * step;
  }
  function niceStepForAmount(amount) {
    var abs = Math.abs(amount);
    if (abs >= 10000) return 100;
    if (abs >= 1000) return 25;
    if (abs >= 100) return 5;
    if (abs >= 10) return 1;
    return 1;
  }

  function applyCharmRounding(rawAmount, code) {
    if (isZeroDecimal(code)) return Math.ceil(rawAmount);
    if (isCharmPricing(code)) {
      var floor = Math.floor(rawAmount);
      var fractional = rawAmount - floor;
      var endings = [0.49, 0.79, 0.99];
      for (var i = 0; i < endings.length; i++) {
        if (fractional <= endings[i]) return parseFloat((floor + endings[i]).toFixed(2));
      }
      return parseFloat((floor + 1.49).toFixed(2));
    }
    var step = niceStepForAmount(rawAmount);
    var rounded = roundUpToStep(rawAmount, step);
    return step >= 1 ? Math.round(rounded) : parseFloat(rounded.toFixed(2));
  }

  function getFractionDigits(amount, code) {
    if (isZeroDecimal(code)) return 0;
    if (isCharmPricing(code)) return 2;
    return Number.isInteger(amount) ? 0 : 2;
  }

  function formatPrice(amount, code) {
    code = code.toUpperCase();
    var fractionDigits = getFractionDigits(amount, code);
    var custom = CUSTOM_SYMBOLS[code];
    if (custom) {
      var num = new Intl.NumberFormat('en-US', { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits }).format(amount);
      return custom + ' ' + num;
    }
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: code, minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits }).format(amount);
    } catch (e) {
      return code + ' ' + amount.toFixed(fractionDigits);
    }
  }

  function formatPriceNumber(amount, code) {
    code = code.toUpperCase();
    var fractionDigits = getFractionDigits(amount, code);
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits }).format(amount);
  }

  function buildSarPriceHtml(amount, code) {
    var numStr = formatPriceNumber(amount, code);
    return SAR_SVG_INLINE + ' ' + numStr;
  }

  function buildAedPriceHtml(amount, code) {
    var numStr = formatPriceNumber(amount, code);
    return AED_SVG_INLINE + ' ' + numStr;
  }

  var _lastRate = 1;
  var _lastCode = 'GBP';
  var bundlerRefreshTimers = [];
  var bundlerMoneySelector = '.bndlr-container .bndlr-money[data-currentprice], .bndlr-container [data-money-convertible][data-currentprice], .bndlr-container .bndlr-money[data-currency-gbp], .bndlr-container [data-money-convertible][data-currency-gbp]';
  var priceMutationSelector = '[data-base-price], ' + bundlerMoneySelector;

  function scheduleBundlerPriceRefresh(rate, toCode) {
    bundlerRefreshTimers.forEach(function (timer) { clearTimeout(timer); });
    bundlerRefreshTimers = [50, 250, 800, 1600, 3200, 5000].map(function (delay) {
      return setTimeout(function () {
        updateBundlerPriceElements(rate, toCode);
      }, delay);
    });
  }

  function updatePriceElements(rate, toCode) {
    _lastRate = rate;
    _lastCode = toCode || 'GBP';
    toCode = toCode || 'GBP';
    document.querySelectorAll('[data-base-price]').forEach(function (el) {
      var raw = parseFloat(el.getAttribute('data-base-price'), 10);
      if (isNaN(raw)) return;
      var base = el.getAttribute('data-base-price-unit') === 'cents' ? raw / 100 : raw;
      var converted = base * rate;
      // data-exact-conversion remains available for special cases, but normal
      // storefront/cart pricing now uses the same rounded amount that Store B charges.
      var exact = el.hasAttribute('data-exact-conversion');
      var rounded;
      if (rate === 1) {
        rounded = converted;
      } else if (exact) {
        var fd = isZeroDecimal(toCode) ? 0 : 2;
        rounded = parseFloat(converted.toFixed(fd));
      } else {
        rounded = applyCharmRounding(converted, toCode);
      }
      if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
        el.value = el.getAttribute('data-currency-format') === 'false' ? String(rounded.toFixed(getFractionDigits(rounded, toCode))) : formatPrice(rounded, toCode);
      } else if (toCode === 'SAR') {
        el.innerHTML = buildSarPriceHtml(rounded, toCode);
      } else if (toCode === 'AED') {
        el.innerHTML = buildAedPriceHtml(rounded, toCode);
      } else {
        var text = el.getAttribute('data-currency-format') === 'false' ? String(rounded.toFixed(getFractionDigits(rounded, toCode))) : formatPrice(rounded, toCode);
        el.textContent = text;
      }
    });
    updateBundlerPriceElements(rate, toCode);
    scheduleBundlerPriceRefresh(rate, toCode);
    var tooltipText = (CURRENCY_NAMES[toCode] || toCode) + ' (' + toCode + ')';
    var currencyTooltipRe = /Dollar|Pound|Euro|Riyal|Dirham|GBP|USD|EUR|SAR|AED|\([A-Z]{3}\)\s*$/i;
    function updateTooltipEl(t) {
      var cur = t.getAttribute('data-tippy-content') || '';
      if (!currencyTooltipRe.test(cur)) return;
      t.setAttribute('data-tippy-content', tooltipText);
      var inst = t._tippy;
      if (inst) {
        if (typeof inst.setContent === 'function') inst.setContent(tooltipText);
        else if (typeof inst.setProps === 'function') inst.setProps({ content: tooltipText });
      }
    }
    document.querySelectorAll('.prd-price').forEach(function (block) {
      if (!block.querySelector('[data-base-price]')) return;
      block.querySelectorAll('[data-store-currency-tooltip], [data-tippy-content]').forEach(updateTooltipEl);
    });
    document.querySelectorAll('[data-base-price]').forEach(function (el) {
      var node = el.parentElement;
      while (node && node !== document.body) {
        if (node.getAttribute && node.getAttribute('data-tippy-content')) updateTooltipEl(node);
        node = node.parentElement;
      }
    });
    if (sharedState) {
      setTimeout(function () {
        var tooltipText2 = (CURRENCY_NAMES[toCode] || toCode) + ' (' + toCode + ')';
        document.querySelectorAll('[data-base-price]').forEach(function (el) {
          var node = el.parentElement;
          while (node && node !== document.body) {
            if (node.getAttribute && node.getAttribute('data-tippy-content') && currencyTooltipRe.test(node.getAttribute('data-tippy-content') || '')) {
              node.setAttribute('data-tippy-content', tooltipText2);
              if (node._tippy && typeof node._tippy.setContent === 'function') node._tippy.setContent(tooltipText2);
              else if (node._tippy && typeof node._tippy.setProps === 'function') node._tippy.setProps({ content: tooltipText2 });
            }
            node = node.parentElement;
          }
        });
      }, 600);
    }
  }

  function updateBundlerPriceElements(rate, toCode) {
    toCode = (toCode || 'GBP').toUpperCase();
    var convertedCount = 0;
    document.querySelectorAll(bundlerMoneySelector).forEach(function (el) {
      if (el.hasAttribute('data-base-price')) return;
      var raw = parseFloat(el.getAttribute('data-currentprice'), 10);
      if (isNaN(raw)) {
        var gbpText = (el.getAttribute('data-currency-gbp') || '').replace(/[^0-9.]/g, '');
        var gbpAmount = parseFloat(gbpText);
        raw = isNaN(gbpAmount) ? NaN : Math.round(gbpAmount * 100);
      }
      if (isNaN(raw)) return;
      var base = raw / 100;
      var converted = base * rate;
      var exact = el.hasAttribute('data-exact-conversion');
      var rounded;
      if (rate === 1) {
        rounded = converted;
      } else if (exact) {
        var fd = isZeroDecimal(toCode) ? 0 : 2;
        rounded = parseFloat(converted.toFixed(fd));
      } else {
        rounded = applyCharmRounding(converted, toCode);
      }

      var sr = el.querySelector('.sr-only, .bndlr-sr-only');
      var srHtml = sr ? sr.outerHTML : '';
      if (toCode === 'SAR') {
        el.innerHTML = srHtml + buildSarPriceHtml(rounded, toCode);
      } else if (toCode === 'AED') {
        el.innerHTML = srHtml + buildAedPriceHtml(rounded, toCode);
      } else {
        el.innerHTML = srHtml + formatPrice(rounded, toCode);
      }

      if (el.classList) {
        Array.prototype.slice.call(el.classList).forEach(function (className) {
          if (/^gt_currency--[a-z]{3}$/i.test(className)) el.classList.remove(className);
        });
        el.classList.add('gt_currency--' + toCode.toLowerCase());
      }
      el.setAttribute('data-store-currency-converted', toCode);
      convertedCount += 1;
    });
    return convertedCount;
  }

  function getContainers() {
    var list = [];
    var byId = document.getElementById('store-currency-selector');
    if (byId && !byId.dataset.storeCurrencyInited) list.push(byId);
    document.querySelectorAll('[data-store-currency-container]').forEach(function (el) {
      if (!el.dataset.storeCurrencyInited) list.push(el);
    });
    return list;
  }

  function resetCurrencyContainers() {
    var byId = document.getElementById('store-currency-selector');
    if (byId) delete byId.dataset.storeCurrencyInited;
    document.querySelectorAll('[data-store-currency-container]').forEach(function (el) {
      delete el.dataset.storeCurrencyInited;
    });
  }

  function getLabelAndOptions(container) {
    var label = container.querySelector('#store-currency-label') || container.querySelector('[id="store-currency-label"]');
    var optionsEl = container.querySelector('[data-store-currency-options]');
    return { label: label, optionsEl: optionsEl };
  }

  function setActiveInAllLists(code) {
    document.querySelectorAll('[data-store-currency-options]').forEach(function (ul) {
      ul.querySelectorAll('li').forEach(function (li) {
        var a = li.querySelector('a[data-currency]');
        if (a && a.getAttribute('data-currency') === code) {
          li.classList.add('active');
          a.setAttribute('aria-current', 'true');
        } else {
          li.classList.remove('active');
          if (a) a.removeAttribute('aria-current');
        }
      });
    });
  }

  var sharedState = null;

  function readCachedState() {
    try {
      if (!window.localStorage) return null;
      var raw = localStorage.getItem(cacheKey);
      if (!raw) return null;
      var cached = JSON.parse(raw);
      if (!cached || !cached.savedAt || Date.now() - cached.savedAt > cacheTtlMs) return null;
      if (!cached.state || !cached.state.rates || !cached.state.list || !cached.state.list.length) return null;
      return cached.state;
    } catch (e) {
      return null;
    }
  }

  function writeCachedState(state) {
    try {
      if (!window.localStorage || !state || !state.list || !state.list.length) return;
      localStorage.setItem(cacheKey, JSON.stringify({ savedAt: Date.now(), state: state }));
    } catch (e) { }
  }

  function fetchCurrencyInit() {
    var controller = window.AbortController ? new AbortController() : null;
    var timer = null;
    if (controller) {
      timer = setTimeout(function () { controller.abort(); }, initTimeoutMs);
    }
    var params = [];
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      if (tz) params.push('tz=' + encodeURIComponent(tz));
    } catch (e) { }
    try {
      var locale = (navigator.languages && navigator.languages[0]) || navigator.language || '';
      if (locale) params.push('locale=' + encodeURIComponent(locale));
    } catch (e2) { }
    var url = backendUrl + '/api/currency-init' + (params.length ? '?' + params.join('&') : '');
    return fetch(url, {
      credentials: 'include',
      signal: controller ? controller.signal : undefined
    }).then(function (r) {
      if (timer) clearTimeout(timer);
      if (!r.ok) throw new Error('Currency init failed');
      return r.json();
    }).catch(function (err) {
      if (timer) clearTimeout(timer);
      throw err;
    });
  }

  function init() {
    if (!backendUrl) return;
    backendUrl = backendUrl.replace(/\/$/, '');

    var state = sharedState || { base: '', rates: {}, current: '', list: [] };

    function renderList(optionsEl) {
      if (!state.list.length || !optionsEl) return;
      optionsEl.innerHTML = state.list.map(function (code) {
        var active = code === state.current ? ' class="active"' : '';
        var aria = code === state.current ? ' aria-current="true"' : '';
        var name = CURRENCY_NAMES[code] || code;
        var tippy = ' data-tippy-content="' + name.replace(/"/g, '&quot;') + '"';
        return '<li' + active + '><a href="#" data-currency="' + code + '"' + aria + tippy + '>' + code + '</a></li>';
      }).join('');
      optionsEl.querySelectorAll('a[data-currency]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var code = this.getAttribute('data-currency');
          state.current = code;
          setCookie(code);
          setActiveInAllLists(code);
          document.querySelectorAll('#store-currency-label').forEach(function (l) { l.textContent = code; });
          var rate = state.rates[code] || 1;
          updatePriceElements(rate, code);
        });
      });
      var collapse = optionsEl.closest('settings-collapse');
      if (collapse && typeof collapse.reInit === 'function') {
        requestAnimationFrame(function () {
          collapse.reInit();
          var dropdown = collapse.closest('settings-dropdown');
          if (dropdown && typeof dropdown.updateScroll === 'function') dropdown.updateScroll();
        });
      }
    }

    function runUpdatePrices() {
      var code = state.current || state.base || 'GBP';
      window.STORE_CURRENCY_CURRENT = code;
      var rate = state.rates[code] || 1;
      updatePriceElements(rate, code);
    }

    function runWithState(containers) {
      (containers || getContainers()).forEach(function (container) {
        var pair = getLabelAndOptions(container);
        if (!pair.optionsEl) return;
        container.dataset.storeCurrencyInited = '1';
        if (pair.label) pair.label.textContent = state.current;
        renderList(pair.optionsEl);
      });
      runUpdatePrices();
    }

    if (sharedState && sharedState.list.length) {
      state = sharedState;
      applyCookieToState(state);
      runUpdatePrices();
      runWithState(getContainers());
      return;
    }

    var cachedState = readCachedState();
    if (cachedState) {
      state = cachedState;
      applyCookieToState(state);
      sharedState = state;
      runUpdatePrices();
      runWithState(getContainers());
      return;
    } else {
      state.base = 'GBP';
      state.current = getCookie().toUpperCase() || 'GBP';
      state.list = [state.current || 'GBP'];
      state.rates[state.current || 'GBP'] = 1;
      sharedState = state;
      runUpdatePrices();
      runWithState(getContainers());
    }

    fetchCurrencyInit()
      .then(function (data) {
        state.base = data.baseCurrency || data.base;
        state.rates = data.exchangeRates || data.rates || {};
        state.current = data.initialCurrency || data.initial || state.base;
        state.list = data.selectableCurrencies || data.selectable || [state.base];
        if (!state.rates[state.base]) state.rates[state.base] = 1;
        applyCookieToState(state);
        sharedState = state;
        writeCachedState(state);
        runUpdatePrices();
        resetCurrencyContainers();
        runWithState(getContainers());
      })
      .catch(function () {
        state.base = state.base || 'GBP';
        state.current = state.current || state.base;
        state.list = state.list && state.list.length ? state.list : [state.current];
        state.rates[state.current] = state.rates[state.current] || 1;
        applyCookieToState(state);
        sharedState = state;
        runUpdatePrices();
        runWithState(getContainers());
      });
  }

  function tryInit() {
    if (!window.STORE_CHECKOUT_BACKEND_URL) return;
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }

  /** Expose so cart/discount JS can trigger re-run after injecting data-base-price elements */
  window.StoreCurrency = {
    updatePrices: function () {
      if (sharedState) {
        updatePriceElements(_lastRate, _lastCode);
        return updateBundlerPriceElements(_lastRate, _lastCode);
      }
      return 0;
    },
    updateBundlerPrices: function () {
      return updateBundlerPriceElements(_lastRate, _lastCode);
    },
    // Format a value that is already in the target currency (no conversion).
    formatDisplayAmount: function (amount, currencyCode) {
      var code = (currencyCode || _lastCode || 'GBP').toUpperCase();
      var num = Number(amount);
      if (!Number.isFinite(num)) num = 0;
      if (code === 'SAR') return buildSarPriceHtml(num, code);
      if (code === 'AED') return buildAedPriceHtml(num, code);
      return formatPrice(num, code);
    }
  };

  var observer = new MutationObserver(function (mutations) {
    if (!window.STORE_CHECKOUT_BACKEND_URL) return;
    var hasNewContainer = false;
    var hasNewPrice = false;
    function check(node) {
      if (node.nodeType !== 1) return;
      if (node.id === 'store-currency-selector' || node.hasAttribute('data-store-currency-container')) hasNewContainer = true;
      if (node.hasAttribute && (node.hasAttribute('data-base-price') || node.hasAttribute('data-currentprice') || node.hasAttribute('data-currency-gbp'))) hasNewPrice = true;
      if (node.querySelector && (node.querySelector('[data-store-currency-container]') || node.querySelector('#store-currency-selector'))) hasNewContainer = true;
      if (node.querySelector && node.querySelector(priceMutationSelector)) hasNewPrice = true;
    }
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        check(node);
        if (node.querySelectorAll) {
          node.querySelectorAll('[data-store-currency-container], #store-currency-selector').forEach(check);
          if (node.querySelectorAll(priceMutationSelector).length) hasNewPrice = true;
        }
      });
      if (m.type === 'attributes') {
        if (m.attributeName === 'data-store-currency-converted') return;
        check(m.target);
      } else if (m.type === 'characterData' && m.target.parentElement) {
        check(m.target.parentElement);
      }
    });
    if (hasNewContainer) setTimeout(tryInit, 50);
    if (hasNewPrice && sharedState) setTimeout(function () { updatePriceElements(_lastRate, _lastCode); }, 0);
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['data-currentprice', 'data-currency-gbp']
  });
})();
